import React from "react";
import ReactSelect from "@ui/ReactSelect";
import { useEquipmentTypeInput } from "./useEquipmentTypeInput";

interface P {
  focusableRef: React.RefObject<{
    focus: () => void;
  }>;
  name: string;
  placeholder: string;
  entry: { equipmentTypeId: string | null };
  column: string;
  allowEquipmentTypeCreation?: boolean;
  setDirty: (dirty: boolean, column: string) => void;
}

const EquipmentTypeSelect = ({
  name,
  placeholder,
  setDirty,
  entry,
  allowEquipmentTypeCreation = false,
  ...props
}: P) => {
  const equipmentType = useEquipmentTypeInput(entry);

  React.useEffect(() => {
    setDirty(equipmentType.dirty, props.column);
  }, [equipmentType.dirty, props.column, setDirty]);

  return (
    <ReactSelect
      {...props}
      menuPortalTarget={window.document.body}
      ref={props.focusableRef as React.RefObject<HTMLDivElement>}
      name={name}
      placeholder={placeholder}
      value={equipmentType.selectedEquipmentType}
      options={equipmentType.equipmentTypeOptions}
      onChange={equipmentType.handleEquipmentTypeChanged}
      onCreate={allowEquipmentTypeCreation ? equipmentType.handleEquipmentTypeCreated : undefined}
      onEdit={allowEquipmentTypeCreation ? equipmentType.handleEquipmentTypeEdited : undefined}
      onDelete={allowEquipmentTypeCreation ? equipmentType.handleEquipmentTypeDeleted : undefined}
    />
  );
};

export default React.memo(EquipmentTypeSelect);
